interface CarouselItem {
  title: string;
  subtitle: string;
  description: string;
  tag: string;
  imageUrl: string;
}

const carouselItems: CarouselItem[] = [
  {
    title: '韩漫精选：2026上半年必看神作',
    subtitle: '编辑严选 · 高分韩漫合集',
    description: '从恋爱甜宠到悬疑烧脑，为你盘点今年最值得追的韩漫佳作，画风剧情双双在线，每一部都让人欲罢不能。',
    tag: '韩漫专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20artistic%20manga%20themed%20banner%20design%20with%20coral%20red%20and%20cream%20gradients%2C%20abstract%20flowing%20shapes%2C%20soft%20atmospheric%20lighting%2C%20no%20text%20no%20characters%2C%20elegant%20editorial%20style&width=600&height=340&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国漫崛起：这些作品不输日韩',
    subtitle: '国产漫画 · 质量飞跃之作',
    description: '国漫近年精品频出，从仙侠修真到都市科幻，画风和叙事达到国际水准，这些作品值得每一个漫画爱好者关注。',
    tag: '国漫专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20banner%20with%20amber%20golden%20and%20cream%20gradients%2C%20abstract%20brushstroke%20texture%2C%20warm%20energetic%20mood%2C%20no%20text%20no%20characters%2C%20modern%20editorial%20design&width=600&height=340&seq=carousel-02&orientation=landscape',
  },
  {
    title: '日漫经典：不可错过的校园恋爱',
    subtitle: '日漫推荐 · 青春纯爱物语',
    description: '日漫校园题材永不过时，从青涩初恋到热血青春，精选多部口碑日漫，带你重温最美好的校园时光。',
    tag: '日漫专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20soft%20gentle%20banner%20with%20pastel%20coral%20pink%20and%20cream%20gradients%2C%20abstract%20flowing%20petal%20like%20shapes%2C%20light%20airy%20atmosphere%2C%20no%20text%20no%20characters%2C%20dreamy%20editorial%20design&width=600&height=340&seq=carousel-03&orientation=landscape',
  },
  {
    title: '悬疑烧脑：高分推理漫画大盘点',
    subtitle: '推理迷必看 · 反转神作合集',
    description: '层层反转的悬疑推理漫画，每一话都让你猜不到结局。精选多部高分烧脑作品，挑战你的推理能力。',
    tag: '悬疑专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20moody%20dramatic%20banner%20with%20deep%20coral%20and%20charcoal%20gradients%2C%20abstract%20shadowy%20geometric%20shapes%2C%20mysterious%20atmosphere%2C%20no%20text%20no%20characters%2C%20cinematic%20editorial%20design&width=600&height=340&seq=carousel-04&orientation=landscape',
  },
  {
    title: '新番速递：本周最新上架漫画',
    subtitle: '新鲜出炉 · 第一时间尝鲜',
    description: '每周精选最新上架的漫画作品，涵盖各类题材。新作速递让你永远走在追漫第一线，不错过任何一部潜力神作。',
    tag: '新番专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20fresh%20vibrant%20banner%20with%20warm%20coral%20orange%20and%20cream%20gradients%2C%20abstract%20dynamic%20swirling%20shapes%2C%20energetic%20fresh%20mood%2C%20no%20text%20no%20characters%2C%20modern%20editorial%20design&width=600&height=340&seq=carousel-05&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
          精选专题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
          编辑团队精心策划的漫画专题合集
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 3).map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-44 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-primary-600 font-medium mb-1">{item.subtitle}</p>
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {carouselItems.slice(3).map((item, idx) => (
            <a
              key={idx + 3}
              href="#cards"
              className="group flex flex-col sm:flex-row rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full sm:w-48 h-36 sm:h-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1">
                <p className="text-xs text-primary-600 font-medium mb-1">{item.subtitle}</p>
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}